import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';

const PageLayout = ({ children }) => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <main className="pt-20 md:pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default PageLayout;
